import React from 'react';
import { Calculator, Menu } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import { useLocalizedPath } from '../hooks/useLocalizedPath';

const Header = ({ onMenuToggle }) => {
  const { t } = useTranslation();
  const { getLocalizedPath } = useLocalizedPath();

  return (
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={onMenuToggle}
              className="lg:hidden p-2 hover:bg-gray-100 rounded"
            >
              <Menu size={20} className="text-gray-600" />
            </button>
            <a href={getLocalizedPath('/')} className="flex items-center gap-2">
              <Calculator className="text-[#4a7c9b] w-8 h-8" />
              <span className="text-xl font-semibold text-gray-800">{t('header.siteName')}</span>
            </a>
          </div>
          <div className="flex items-center">
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
